<template>
  <div id="map-container" v-loading="!loaded">
    <div id="map-info" v-bind:style="{ height }"></div>
  </div>
</template>

<script>
import { decodeRSA } from '../../../mixins/function';
import GoogleMapsLoader from './config';

export default {
  name: 'MapRoutes',
  data() {
    return {
      center: {
        lat: -33.435774,
        lng: -70.660690,
      },
      map: null,
      loaded: false,
      markers: [],
      google: null,
      infoWindows: [],
      zoomControl: true,
    };
  },
  props: {
    height: {
      type: String,
      default: '100vh',
    },
    width: {
      type: String,
      default: '100%',
    },
    scrollWheel: {
      type: Boolean,
      default: true,
    },
    zoom: {
      type: Number,
      default: 8,
    },
    lat: {
      type: Number,
      default: -33.435774,
    },
    lon: {
      type: Number,
      default: -70.660690,
    },
    index: {
      type: Number,
      default: 0,
    },
    suborder: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    initMap() {
      const element = document.getElementById('map-info');
      GoogleMapsLoader.load((google) => {
        this.google = google;
        this.map = new google.maps.Map(element, {
          zoom: this.zoom,
          center: new google.maps.LatLng(this.lat, this.lon),
          zoomControl: this.zoomControl,
          scrollwheel: this.scrollWheel,
          gestureHandling: 'cooperative',
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT,
          },
        });
      });
    },
    addMarkers() {
      const so = this.suborder;
      const marker = new this.google.maps.Marker({
        title: '1',
        label: `${this.index + 1}`,
        position: new this.google.maps.LatLng(so.point.latitude, so.point.longitude),
        map: this.map,
        // eslint-disable-next-line global-require
        icon: require('../../../assets/img/green_marker_shadow.png'),
        pointData: so,
      });
      this.markers.push(marker);
      const latLng = this.markers[0].getPosition(); // returns LatLng object
      this.map.setCenter(latLng);
      this.loaded = true;
    },
    addEvent() {
      GoogleMapsLoader.load((google) => {
        const map = document.getElementById('route-map');
        const infowindow = new google.maps.InfoWindow({
          content: '',
        });
        this.markers.forEach((element) => {
          let contentString;
          if (element.pointData.customer) {
            contentString = `<div class="infowindowContainer">
            <p class="titleStyle">${decodeRSA(element.pointData.customer.full_name)}</p>
            <p class="addressStyle">${element.pointData.raw_address}, ${element.pointData.point.street.commune.name}</p>
            <p class="nOrderStyle"><span>Nº Orden: ${element.pointData.suborder.code}</span></p>
            <p class="numberStyle"><i class="fa fa-mobile"></i> ${decodeRSA(element.pointData.customer.phone)}</p>
            <p class="genericTitle"><span class="bold">PRODUCTOS:</span></p>`;
            element.pointData.suborder.packages.forEach((product) => {
              contentString += `<p class="productStyle">${product.description}</p>`;
            });
            contentString += '</div>';
          } else if (!element.pointData.customer) {
            contentString = `<div><p class="ctName">${element.pointData.name}</p></div>`;
          }
          element.addListener('click', () => {
            infowindow.close();
            infowindow.setContent(contentString);
            infowindow.open(map, element);
          });
        });
        google.maps.event.trigger(this.markers[0], 'click');
      });
    },
    cleanMap() {
      this.markers.forEach((element) => {
        element.setMap(null);
      });
      this.markers = [];
    },
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  watch: {
    suborder() {
      if (this.suborder && !this.loaded) {
        this.cleanMap();
        this.addMarkers();
        this.addEvent();
        this.loaded = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #routeMap {
    width: 100%;
    height: 100vh;
  }
  .infowindowContainer{
    width: 350px!important;
    height: 200px!important;
    text-align: left!important;
    color: #707070!important;
  }
  .titleStyle {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }
  .addressStyle {
    font-size: 14px;
    font-weight: normal;
    margin: 0;
  }
  .ctName {
    font-size: 14px;
    font-weight: 800;
    margin: 0;
  }
  .nOrderStyle  {
    margin: 5px 0;
  }
  .nOrderStyle span {
    background-color: #9B9B9B;
    color: #FFFFFF;
    font-weight: bold;
    padding: 2px 5px;
    display: inline-block;
  }
  .numberStyle {
    font-size: 13px;
    display: inline-block;
    margin: 0;
  }
  .descriptionStyle {
    margin: 0;
  }
  .genericTitle {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .fa.fa-mobile {
    font-size: 20px;
    margin: 0 5px;
    vertical-align: sub;
    color: #A0BE03;
  }
  .productStyle {
    margin: 5px;
  }
  .productStyle::before {
    content: "• ";
    color: #A0BE03;
  }
</style>
